import React from "react";
import ReactWizard from "../Wizard";
import SimOverviewInformation from "./components/SimUsageComponents/SimOverviewInformation";
import SimPlansInformation from "./components/SimUsageComponents/SimPlansInformation";
import SimOverageInformation from "./components/SimUsageComponents/SimOverageInformation";
import SimUsageInformation from "./components/SimUsageComponents/SimUsageInformation";

const STEPS = [
  {
    stepName: "Overview",
    component: SimOverviewInformation,
  },
  {
    stepName: "Plans",
    component: SimPlansInformation,
  },
  {
    stepName: "Usage",
    component: SimUsageInformation,
  },
  {
    stepName: "Overage",
    component: SimOverageInformation,
  },
];

const SimUsageForm = (props) => {
  const {onFormSubmit} = props;
  return (
    <ReactWizard
      steps={STEPS}
      title={"Sim Usage"}
      finishButtonText={"Close"}
      finishButtonClick={onFormSubmit}
    />
  );
};

export default SimUsageForm;
